import { ICOLUMN_PROP_NAMES, IEXTENSION_PROP_NAMES } from '../../constants/MDLComputations.constants';
import _ from 'lodash';
export const getIsForaySegmentAsBool = (computation) => {
    var _a;
    const foraySegmentText = (_a = computation.Extensions) === null || _a === void 0 ? void 0 : _a[IEXTENSION_PROP_NAMES.foray_isForaySegment];
    return (!!computation.Extensions &&
        (foraySegmentText === 'true' || Object.entries(foraySegmentText || {}).some(([k, v], i) => v.toLowerCase() === 'true')));
};
export const toBeDeletedSegment = (segmentsToDelete, computation) => {
    if (!getIsForaySegmentAsBool(computation)) {
        return false;
    }
    const column = computation;
    return segmentsToDelete.some((s) => s.level === column[ICOLUMN_PROP_NAMES.level] &&
        s.name === column[ICOLUMN_PROP_NAMES.name]);
};
/** Returns whether the given segment matches the given computation assuming they are from the same computation file */
export const segmentMatchesComputation = (segment, computation, isColumn) => {
    const computationColumn = computation;
    const isSegment = getIsForaySegmentAsBool(computation);
    const isCorrectType = computationColumn['@c'] === 'Column' && (isColumn ? !isSegment : isSegment);
    return isCorrectType && segment['@Level'] === computationColumn['@Level'] && segment['@Name'] === computationColumn['@Name'];
};
export const addOrUpdateMDLComputationFile = (computationsFile, newSegment, oldSegment, isColumn = false) => {
    // deep copy object
    const computations = Object.assign(Object.assign({}, computationsFile), { Mdl: Object.assign(Object.assign({}, computationsFile.Mdl), { Computations: Object.assign(Object.assign({}, computationsFile.Mdl.Computations), { i: [...computationsFile.Mdl.Computations.i] }) }) });
    if (!oldSegment) {
        computations.Mdl.Computations.i.push(newSegment);
    }
    else {
        const editIndex = computations.Mdl.Computations.i.findIndex((c) => segmentMatchesComputation(oldSegment, c, isColumn));
        computations.Mdl.Computations.i[editIndex] = newSegment;
    }
    return computations;
};
export const addOrUpdateMetricsInMDLComputationFile = (computationsFile, newMetric) => {
    const computations = Object.assign(Object.assign({}, computationsFile), { Mdl: Object.assign(Object.assign({}, computationsFile.Mdl), { Computations: Object.assign(Object.assign({}, computationsFile.Mdl.Computations), { i: [...computationsFile.Mdl.Computations.i] }) }) });
    const editIndex = computations.Mdl.Computations.i.findIndex((c) => newMetric['@Name'] === c['@Name']);
    if (editIndex >= 0) {
        computations.Mdl.Computations.i[editIndex] = newMetric;
    }
    else {
        computations.Mdl.Computations.i.push(newMetric);
    }
    return computations;
};
export const addOrUpdateInstancesInMDLComputationFile = (computationsFile, templateInstance, oldComputationTemplateInstance) => {
    const computations = Object.assign(Object.assign({}, computationsFile), { Mdl: Object.assign(Object.assign({}, computationsFile.Mdl), { Computations: Object.assign(Object.assign({}, computationsFile.Mdl.Computations), { i: [...computationsFile.Mdl.Computations.i] }) }) });
    if (oldComputationTemplateInstance) {
        const editIndex = computations.Mdl.Computations.i.findIndex((c) => _.isEqual(oldComputationTemplateInstance, c));
        computations.Mdl.Computations.i[editIndex] = templateInstance;
    }
    else {
        computations.Mdl.Computations.i.push(templateInstance);
    }
    return computations;
};
export const renameStatistic = (rootObj, oldName, newName) => {
    const tabs = rootObj.Mdl.Extensions['foray:Layout']['foray:Tab'];
    for (const tab of tabs) {
        for (const group of tab['foray:Group']) {
            for (const metric of group.i) {
                if (metric['@c'] === '{extension://MDLConverters/ForayConverter}Statistic' && metric['@Name'] === oldName) {
                    metric['@Name'] = newName;
                }
            }
        }
    }
};

//# sourceMappingURL=MDLComputations.utils.js.map
